import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'ticketLogTime',
  standalone: false,
})
export class TicketLogTimePipe implements PipeTransform {
  transform(startDate?: any, endDate?: any): any {
    if (!startDate) {
      return null;
    }

    let endDateTime = endDate ? new Date(endDate).getTime() : new Date().getTime();

    return this.getDaysHoursAndMinutesFromTime(endDateTime - new Date(startDate).getTime());
  }

  getDaysHoursAndMinutesFromTime(time: number): string {
    let d = moment.duration(time);
    let hours = Math.floor(d.asHours());
    let minutes = moment.utc(time).format('m');
    let seconds = moment.utc(time).format('s');
    let totalTime = '';
    if (hours > 0) {
      totalTime += hours + 'h ';
    }
    if (parseInt(minutes) > 0) {
      totalTime += minutes + 'm ';
    }
    if (parseInt(seconds) > 0) {
      totalTime += seconds + 's';
    }
    return totalTime;
  }
}
